import { render, staticRenderFns } from "./batch-table.vue?vue&type=template&id=3d81b9a2&scoped=true&"
import script from "./batch-table.vue?vue&type=script&lang=js&"
export * from "./batch-table.vue?vue&type=script&lang=js&"
import style0 from "./batch-table.vue?vue&type=style&index=0&id=3d81b9a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d81b9a2",
  null
  
)

export default component.exports